<template>
  <div
    id="form-search-popover"
    class="component-card container-app-search">
    <j-title-header :options="title"/>

    <div class="d-flex m__b--20">
      <div
        :class="{'tab-experience-manager-active' : tabSelected === 'tugas'}"
        class="tab-experience-manager m__r--15 p__l--10 p__r--10"
        @click="selectTab('tugas')">
        SURAT TUGAS
      </div>
      <div
        :class="{'tab-experience-manager-active' : tabSelected === 'keputusan'}"
        class="tab-experience-manager m__r--15 p__l--10 p__r--10"
        @click="selectTab('keputusan')">
        SURAT KEPUTUSAN
      </div>
      <div
        :class="{'tab-experience-manager-active' : tabSelected === 'agenda'}"
        class="tab-experience-manager m__r--15 p__l--10 p__r--10"
        @click="selectTab('agenda')">
        AGENDA SURAT
      </div>
    </div>

    <v-server-table
      v-show="load_first"
      ref="tableServer"
      :columns="columns"
      :options="options"
      class="jTable"
      @loading="loading"
      @loaded="loaded">
      <div
        slot="beforeFilter"
        class="custom-search">
        <b-form inline>
          <b-button
            class="btn grey btn-import-form m__r--5"
            @click="createData">
            <i class="fa fa-plus fa-lg"/> Add
          </b-button>
          <!-- <b-button
            id="searchData"
            class="btn grey btn-import-form"
            @click="popoverSearchShow = true">
            <i class="fa fa-search fa-lg"/> Search
          </b-button> -->
        </b-form>
      </div>

      <div
        slot="id"
        slot-scope="props"
        style="width: 50px"
        @click="clickDetail(props.row)">
        {{ props.row.id }}
      </div>

      <div
        slot="nomor"
        slot-scope="props"
        style="width: 200px"
        @click="clickDetail(props.row)">
        {{ props.row.nomor }}
      </div>

      <div
        slot="title"
        slot-scope="props"
        style="width: 150px"
        @click="clickDetail(props.row)">
        {{ props.row.title }}
      </div>

      <div
        slot="category_name"
        slot-scope="props"
        style="width: 100px"
        @click="clickDetail(props.row)">
        {{ props.row.category_name }}
      </div>

      <div
        slot="status"
        slot-scope="props"
        @click="clickDetail(props.row)">
        {{ props.row.status.toUpperCase() }}
      </div>

      <div
        slot="created_date"
        slot-scope="props"
        style="width: 150px"
        @click="clickDetail(props.row)">
        {{ props.row.created_date }}
      </div>

      <div
        slot="updated_date"
        slot-scope="props"
        style="width: 150px"
        @click="clickDetail(props.row)">
        {{ props.row.updated_date }}
      </div>

      <div
        slot="action"
        slot-scope="props">
        <b-button
          v-if="props.row.file_generate"
          class="btn green btn-import-form"
          @click="downloadSurat(props.row.file_generate)">
          <i class="fa fa-lg fa-download"/>
        </b-button>
      </div>
    </v-server-table>
    <jLoadingTable v-if="!load_first"/>

    <b-popover
      ref="searchModal"
      :show.sync="popoverSearchShow"
      container="form-search-popover"
      target="searchData"
      placement="right">
      <div class="m__b--10">Search Data</div>
      <b-form
        inline
        @keypress.13.prevent="filter(filter_data)">
        <j-select
          v-model="select_type"
          :disabled="false"
          :options="options_search"
          class="m__r--5"/>
        <j-input
          v-model="filter_data"
          placeholder="Search"
          class="m__r--5"/>
        <b-button
          class="btn blue outline"
          style="margin-top: -19px;"
          @click="filter(filter_data)">
          <i class="fa fa-search bold" /> Search
        </b-button>
      </b-form>
    </b-popover>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions } from 'vuex';
import jApiKurikulum from '@/services/jApiKurikulum';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';

export default {
  components: {
    jLoadingTable,
  },
  data() {
    return {
      title: {
        icon: 'fa-file',
        main_title: 'Administrasi Surat Menyurat',
        opt_title: 'Requester',
      },
      tabSelected: 'tugas',
      popoverSearchShow: false,
      filter_data: '',
      select_type: 'title',
      options_search: [
        {
          text: 'TITLE',
          value: 'title',
        },
        {
          text: 'CATEGORY',
          value: 'category_name',
        },
      ],
      load_first: false,
      length_table: '',
      data_table: [],
      selected_rows: [],
      columns: ['id', 'nomor', 'title', 'category_name', 'status', 'created_date', 'updated_date', 'action'],
      options: {
        headings: {
          id: 'ID',
          nomor: 'NOMOR',
          title: 'TITLE',
          category_name: 'CATEGORY',
          status: 'STATUS',
          created_date: 'CREATED DATE',
          updated_date: 'UPDATED DATE',
          action: 'ACTION',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        debounce: 1000,
        filterable: true,
        sortable: ['id', 'nomor', 'title', 'category_name', 'status', 'created_date', 'updated_date'],
        perPage: 10,
        perPageValues: [5, 10, 20, 50, 100],
        requestAdapter(data) {
          return {
            limit: data.limit,
            page: data.page,
            module_id: data.module,
            category_id: data.category_id,
          };
        },
        requestFunction(data) {
          const getList = jApiKurikulum.getListAdminPembelajaran(data);
          return getList.catch((e) => {
            this.$store.dispatch('jStoreNotificationScreen/getProblemMessage', e.response.data.errors[0].message).bind(this);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.length ? data.length : 0,
          };
        },
      },
    };
  },
  computed: {
  },
  watch: {
    filter_data(val) {
      if (val === '') {
        this.$refs.tableServer.setFilter('');
      }
    },
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'showLoading', 'hideLoading', 'toggleProblem']),

    selectTab(status) {
      this.tabSelected = status;
      this.refreshTable();
    },

    loading(val) {
      const a = val;
      a.module_id = 2;

      switch (this.tabSelected) {
        case 'tugas':
          a.category_id = 5;
          break;
        case 'keputusan':
          a.category_id = 4;
          break;
        case 'agenda':
          a.category_id = 6;
          break;
        default :
          a.category_id = 0;
      }

      if (this.load_first) {
        this.showLoading();
      }
    },

    loaded(data) {
      this.data_table = data.data.data;

      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },

    refreshTable() {
      this.$refs.tableServer.getData();
    },

    filter(val) {
      this.$refs.tableServer.setFilter(val);
    },

    clickDetail(row) {
      this.$router.replace(`/admin-surat/requester/detail/${row.id}`);
    },

    createData() {
      let categoryId = 0;
      switch (this.tabSelected) {
        case 'tugas':
          categoryId = 5;
          break;
        case 'keputusan':
          categoryId = 4;
          break;
        case 'agenda':
          categoryId = 6;
          break;
        default :
          categoryId = 0;
      }
      this.$router.replace(`/admin-surat/requester/create/${categoryId}`);
    },

    downloadSurat(url) {
      window.open(url);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/kurikulum/admin-surat/jAdminSuratList.vue